import { useCallback, useMemo, useState } from "react";

import { useGlobalFiltersContext } from "../global-filters";
import {
  flattenCheckboxValues,
  initHierarchyIdsCheckedState,
} from "../helpers";

import { SystemOverviewFiltersContext } from "./context";
import type { SystemOverviewFilters } from "./types";

export const SystemOverviewFiltersProvider = ({
  children,
}: React.PropsWithChildren) => {
  const { hierarchyIdCheckboxes, appliedHierarchyIdCheckboxStatesOverview } =
    useGlobalFiltersContext();

  const initialSelectedHierarchyIdCheckboxStatesOverview = useMemo(() => {
    return (
      appliedHierarchyIdCheckboxStatesOverview ??
      initHierarchyIdsCheckedState(flattenCheckboxValues(hierarchyIdCheckboxes))
    );
  }, [appliedHierarchyIdCheckboxStatesOverview, hierarchyIdCheckboxes]);

  const [
    selectedHierarchyIdCheckboxStatesOverviewInternal,
    setSelectedHierarchyIdCheckboxStatesOverviewInternal,
  ] =
    useState<
      SystemOverviewFilters["selectedHierarchyIdCheckboxStatesOverview"]
    >();
  const selectedHierarchyIdCheckboxStatesOverview =
    selectedHierarchyIdCheckboxStatesOverviewInternal ??
    initialSelectedHierarchyIdCheckboxStatesOverview;
  const setSelectedHierarchyIdCheckboxStatesOverview: SystemOverviewFilters["setSelectedHierarchyIdCheckboxStatesOverview"] =
    useCallback(
      (nextState) => {
        setSelectedHierarchyIdCheckboxStatesOverviewInternal((currentState) =>
          typeof nextState === "function"
            ? nextState(
                currentState ??
                  initialSelectedHierarchyIdCheckboxStatesOverview,
              )
            : nextState,
        );
      },
      [initialSelectedHierarchyIdCheckboxStatesOverview],
    );

  const value = useMemo<SystemOverviewFilters>(
    () => ({
      selectedHierarchyIdCheckboxStatesOverview,
      setSelectedHierarchyIdCheckboxStatesOverview,
    }),
    [
      selectedHierarchyIdCheckboxStatesOverview,
      setSelectedHierarchyIdCheckboxStatesOverview,
    ],
  );

  return (
    <SystemOverviewFiltersContext.Provider value={value}>
      {children}
    </SystemOverviewFiltersContext.Provider>
  );
};
